"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateTextWithPlaceholdersTable = exports.evaluateTextWithPlaceholdersArray = exports.tokeniseString = exports.evaluateLatexPlaceholders = exports.evaluatePlaceholders = void 0;
const tokeniser_1 = require("./tokeniser");
const token_utils_1 = require("./token-utils");
const types_1 = require("./types");
const matchers_1 = require("./matchers");
const index_1 = __importDefault(require("./index"));
const value_wrappers_1 = require("../value-wrappers");
const expressions_1 = require("./expressions");
// Regular expressions used to match token value-types at the start of the text.
const placeholderMatchers = [
    matchers_1.PlaceholderMatcherAlt, // or §expression§
    matchers_1.PlaceholderMatcher, // placeholders are of the form ${expression}
    matchers_1.DollarMatcher,
    matchers_1.StringMatcher,
];
// Returns true if there's a variable name that doesn't appear
// in the provided list of state keys.
function hasMissingVariable(variableNames, stateKeys) {
    return variableNames.some((v) => !stateKeys.includes(v));
}
// Replaces the variables in a piece of text with the matching values
// in the state object.
function evaluatePlaceholders(text, state = {}, matchers = placeholderMatchers) {
    const tokens = (0, tokeniser_1.getTokens)(text, matchers).map((t) => {
        if (t.type !== types_1.TokenType.PLACEHOLDER)
            return (0, value_wrappers_1.makeValue)(t.value);
        const innerValue = (0, token_utils_1.stripSymbols)(t.value);
        const variableFromState = (0, token_utils_1.getVariableFromState)(innerValue, state);
        return variableFromState !== undefined
            ? (0, value_wrappers_1.makeValue)(variableFromState, [innerValue])
            : (0, expressions_1.evaluateExpression)(innerValue, state);
    });
    const error = tokens.find((t) => t.kind === 'error');
    return error ? error : (0, value_wrappers_1.makeValue)(tokens.map((t) => t.value).join(''), [...tokens.reduce((soFar, t) => {
            var _a;
            for (const v of ((_a = t.variables) !== null && _a !== void 0 ? _a : []))
                soFar.add(v);
            return soFar;
        }, new Set())]);
}
exports.evaluatePlaceholders = evaluatePlaceholders;
// Replaces the variables in a piece of latex with the matching values
// in the state object.
function evaluateLatexPlaceholders(latex, state = {}, matchers = placeholderMatchers) {
    const varRE = /\\var{[a-z]*?}{([^}]*)}/g;
    const latexVarsReplaced = latex.replace(varRE, (_, placeholder) => ('${' + placeholder + '}'));
    return evaluatePlaceholders(latexVarsReplaced, state, matchers);
}
exports.evaluateLatexPlaceholders = evaluateLatexPlaceholders;
function tokeniseString(text, state = {}, matchers = placeholderMatchers) {
    const tokens = (0, tokeniser_1.getTokens)(text, matchers).map((t) => {
        if (t.type !== types_1.TokenType.PLACEHOLDER)
            return { type: 'string', value: (0, value_wrappers_1.makeValue)(t.value, []) };
        const innerValue = (0, token_utils_1.stripSymbols)(t.value);
        const variableFromState = (0, token_utils_1.getVariableFromState)(innerValue, state);
        return variableFromState !== undefined
            ? { name: innerValue, type: 'variable', value: (0, value_wrappers_1.makeValue)(variableFromState, [innerValue]) }
            : { name: innerValue, type: 'expression', value: (0, expressions_1.evaluateExpression)(innerValue, state) };
    });
    const error = tokens.find((t) => t.value.kind === 'error');
    const variableSet = tokens.reduce((soFar, token) => {
        var _a;
        for (const v of ((_a = token.value.variables) !== null && _a !== void 0 ? _a : []))
            soFar.add(v);
        return soFar;
    }, new Set());
    return error
        ? (0, value_wrappers_1.makeError)(error.value.value)
        : (0, value_wrappers_1.makeValue)(tokens.map((t) => (Object.assign(Object.assign({}, t), { value: t.value.value }))), [...variableSet]);
}
exports.tokeniseString = tokeniseString;
function evaluateTextWithPlaceholdersArray(text, state) {
    var _a, _b;
    const textToParse = Array.isArray(text) ? text : [text];
    const steps = (textToParse).map((step = '') => index_1.default.evaluatePlaceholders(step, state));
    return steps.some((step) => step.kind === 'error')
        ? (0, value_wrappers_1.makeError)((_b = (_a = (steps !== null && steps !== void 0 ? steps : []).find((s) => s.kind === 'error')) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '')
        : (0, value_wrappers_1.makeValue)(steps.map((s) => s.value));
}
exports.evaluateTextWithPlaceholdersArray = evaluateTextWithPlaceholdersArray;
function evaluateTextWithPlaceholdersTable(rows, state) {
    let error = null;
    if (!rows)
        return (0, value_wrappers_1.makeError)('There is no data for the table.');
    const data = rows.map((row) => {
        return row.map((cell) => {
            const cellData = index_1.default.evaluatePlaceholders(cell, state);
            if (!error && cellData.kind === 'error')
                error = cellData;
            return cellData.value;
        });
    });
    return error ? error : (0, value_wrappers_1.makeValue)(data);
}
exports.evaluateTextWithPlaceholdersTable = evaluateTextWithPlaceholdersTable;
